import { getTooltip, getPromotionsData } from '../../utils/promotions-helper';

export default class PromotionsHelperAPI {
  constructor(parent) {
    this.parent = parent;
    this.el = parent.el;
    this.pricing = parent.pricing;
    this.tooltipOptions = {
      onCreate: this.tooltipOnCreate.bind(this),
    }
  }

  getMTOPromotions() {
    return this.pricing.mtoPricing?.data?.reduce((map, mtoPricing) => {
      const ean = mtoPricing['ean'];
      map[ean] =  getPromotionsData(mtoPricing['c_productPromotions']);
      return map;
    }, {}) || {};
  }

  getMTOPromotionTooltips() {
    const promotions = this.getMTOPromotions();
    return Object.fromEntries(Object.entries(promotions).map(([k, v]) => [k, getTooltip(v)]));
  }

  getColourTrimPromotionsMTO() {
    const data = this.pricing.getCarMTOPricing();
    if(data && data['c_mtocc']) {
        return data['c_mtocc'].reduce((map, mtoc) => {
            const key = `${mtoc.c_extColourCode}|${mtoc.c_extColourCode}`;
            map[key] = getPromotionsData(mtoc['c_productPromotions']);
            return map;
        }, {});
    }
    return {};
  }

  getColourTrimPromotions() {
      return this.pricing.mtoPricing?.data
          .flatMap((p) => p['c_mtocc'])
          .filter((e) => e)
          .reduce((map, mtoc) => {
              const key = `${mtoc.c_extColourCode}|${mtoc.c_extColourCode}`;
              map[key] = getPromotionsData(mtoc['c_productPromotions']);
              return map;
          }, this.getColourTrimPromotionsMTO()) ?? {}; // Prioritises prices from current MTO by starting the reduce with the current MTO prices
  }

  getColourTrimPromotionTooltips() {    
      const promotions = this.getColourTrimPromotions();
      return Object.fromEntries(Object.entries(promotions).map(([k, v]) => [k, getTooltip(v)]));    
  }

  getAccessoryPromotionsMTO() {
      const data = this.pricing.getCarMTOPricing();
      if(data && data['c_euroOptions']) {
          return data['c_euroOptions'].reduce((map, accessory) => {
              map[accessory.ean] = getPromotionsData(accessory['c_productPromotions']);
              return map;
          }, {});
      }
      return {};
  }

  getAccessoryPromotions() {
      return this.pricing.mtoPricing?.data
          .flatMap((p) => p.c_euroOptions)
          .filter((e) => e)
          .reduce((map, accessory) => {
              map[accessory.ean] ?? (map[accessory.ean] = getPromotionsData(accessory['c_productPromotions']));
              return map;
          }, this.getAccessoryPromotionsMTO()) ?? {}; // Prioritises promotions from current MTO by starting the reduce with the current MTO promotions
  }

  getAccessoryPromotionTooltips() {    
    const promotions = this.getAccessoryPromotions();
    return Object.fromEntries(Object.entries(promotions).map(([k, v]) => [k, getTooltip(v)]));    
  }

  getAdditionalProductPromotions() {
    const data = this.pricing.getCarMTOPricing();
    if(data && data['c_additionalProducts']) {
        return data['c_additionalProducts'].reduce((map, product) => {
            map[product.ean] = getPromotionsData(product['c_productPromotions']);
            return map;
        }, {});
    }
    return {};
  }

  getAdditionalProductPromotionTooltips() {    
    const promotions = this.getAdditionalProductPromotions();
    return Object.fromEntries(Object.entries(promotions).map(([k, v]) => [k, getTooltip(v)]));    
  }

  getCarColourTrimPromitions() {
    const colourTrim = this.pricing.getCarColourTrim();
    return getPromotionsData(colourTrim['c_productPromotions'])
  }
  
  getCarColourTrimTooltip() {
    const promotions = this.getCarColourTrimPromitions();
    return getTooltip(promotions);
  }

  getCarMTOCEPromotions() {
    const promotions = this.pricing.carMTOCEPricing['c_productPromotions'] ?? [];
    return getPromotionsData(promotions)?.map((promotion) => this.addTooltip(promotion)) ?? [];
  }

  getCarAdditionalProductPromotions() {
    const additionalProducts = this.pricing.getCarAdditionalProducts();
    const promotions = additionalProducts?.flatMap((ap) => ap['c_productPromotions'] ?? []) ?? [];
    return getPromotionsData(promotions)?.map((promotion) => this.addTooltip(promotion)) ?? [];
  }

  getCarPromotions() {
    return [
      ...this.getCarMTOCEPromotions(),
      ...this.getCarAdditionalProductPromotions(),
    ]
  }

  getCarPromotionsDiscountTotal() {
    return this.getCarPromotions().reduce((acc, curr) => acc + (Number(curr.discountValue ?? NaN)), 0);
  }

  addTooltip(promotion) {
      return {
        ...promotion,
        tooltip: getTooltip([ promotion ]),
      }
  }

  tooltipOnCreate(instance) {
    const self = this;
    const container = instance.popper.querySelector('.discount-tooltip-container');
    container?.addEventListener('click', (e) => {
        e.stopPropagation();
        
        const el = e.target;
        const href =  el?.getAttribute('href');
        const isAnchor = el?.tagName?.toLowerCase() === 'a';
        const isHashLink = href?.startsWith('#');
        if(isAnchor && isHashLink) {
          e.preventDefault();
          self.parent.navigation.scrollToSection(href);
        }
    });
  }
}